<button class="btn del_i_btn">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.REMOVE' | translate }}">delete_outline</i>
</button>